import { Component, Input, ViewChild, ElementRef, OnInit } from "@angular/core";
import { trimTextByWord } from "../../admin/events-screen/utils/trimTextByWord";
import { DataService } from "../../_services/data.service";
import { GlobalDataService } from "../../_services/global-data.service";
import { MultiSelectComponent } from "../../admin/components/multi-select/multi-select.component";

export interface OrgansMultiSelectValue {
  id: string;
  type: "county" | "nest" | "circle";
}

@Component({
  selector: "multi-select-nests",
  templateUrl: "multi-select-nests.component.html",
  styleUrls: ["multi-select-nests.component.scss"],
})
export class MultiSelectNestsComponent implements OnInit {
  @Input("displayType") public displayType: "smallHeight" | "largeHeight" =
    "largeHeight";
  @ViewChild("nestSelect") public nestSelect: MultiSelectComponent;
  public nestsWithCircles: any[];
  public initNestWithCircles: any[];
  constructor(
    private dataService: DataService,
    private globalDataService: GlobalDataService
  ) {}
  public ngOnInit() {
    this.loadNestsData().then();
  }

  public getSelectedNest(): OrgansMultiSelectValue[] {
    return (
      (this.nestSelect.submit() as any).nestForm ||
      ([] as OrgansMultiSelectValue[])
    );
  }
  private loadDataFromService() {
    // this.dataService.getPaymentFilters().subscribe((data) => {
    //   this.filters = data;
    //   this.nestsWithCircles = [
    //     ...data.nestsWithCircles.circles,
    //     ...data.nestsWithCircles.counties,
    //     ...data.nestsWithCircles.nests,
    //   ];
    //   if (
    //     user.circles.filter((circle) => circle.name === "ALL").length === 0 &&
    //     user.counties.filter((county) => county.name === "ALL").length === 0
    //   ) {
    //     if (user.nests.filter((nest) => nest.name === "ALL").length > 0) {
    //       this.initNestWithCircles = data.nestsWithCircles.counties.filter(
    //         (county) => {
    //           return (
    //             user.counties.filter(
    //               (user_county) => user_county.countyId === county.id
    //             ).length === 1
    //           );
    //         }
    //       );
    //     } else {
    //       this.initNestWithCircles = data.nestsWithCircles.nests.filter(
    //         (nest) => {
    //           return (
    //             user.nests.filter((user_nest) => user_nest.nestId === nest.id)
    //               .length === 1
    //           );
    //         }
    //       );
    //     }
    //   }
    // });
  }

  private async loadNestsData() {
    const data = await this.globalDataService.getAllPaymentFilters();

    this.nestsWithCircles = [
      ...data.nestsWithCircles.circles,
      ...data.nestsWithCircles.counties,
      ...data.nestsWithCircles.nests,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/common/multi-select-nests/multi-select-nests.component.ts